module.exports = __webpack_public_path__ + "img/fuwu_hover.e0863e9d.png";